import { gql } from "@apollo/client";

export const CREATE_TRANSACTION_FLOW_RECORD_DOWNLOAD_TASK = gql`
    mutation CreateTransactionFlowRecordDownloadTask($filters: TransactionFlowRecordFilterTypeInput) {
        createTransactionFlowRecordDownloadTask(filters: $filters)
    }
`;

export interface TransactionFlowRecordDownloadTaskResponse {
    createTransactionFlowRecordDownloadTask: string;
}

